import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontIndivisibleVariable, theme } from "shared/lib/styles";

import { EntityOnelineMenu } from "scmp-app/components/entity-oneline-menu";
import {
  MenuItem,
  StyledSwiper,
  StyledSwiperSlide,
} from "scmp-app/components/entity-oneline-menu/styles";
import { responsiveStyles } from "scmp-app/components/header/features/styles";
import type { ResponsiveStyledProps } from "scmp-app/components/header/features/types";
import { HeaderOnelineMenuContainer } from "scmp-app/components/header/header-oneline-menu-container";
import { ToggleContainer } from "scmp-app/components/header/header-oneline-menu-container/header-all-menu/styles";
import { AllMenuContainer } from "scmp-app/components/header/header-oneline-menu-container/styles";

const desktopMenuItemStyle = css`
  color: #111111;
  font-weight: 500;
  font-size: 14px;
  font-family: ${fontIndivisibleVariable};
  text-transform: none;
  font-variation-settings: "wght" 500;
`;

export const Container = styled.div<ResponsiveStyledProps>`
  ${theme.breakpoints.up("desktop")} {
    column-gap: 16px;
    align-items: center;
  }

  ${responsiveStyles}
`;

export const StyledHeaderOnelineMenuContainer = styled(HeaderOnelineMenuContainer)`
  display: none;

  margin-inline-start: 0;

  ${theme.breakpoints.up("desktop")} {
    display: flex;
    align-items: center;
  }

  ${AllMenuContainer} {
    display: none;

    ${theme.breakpoints.up("desktop")} {
      display: flex;
    }

    ${ToggleContainer} {
      gap: 0;

      span {
        ${desktopMenuItemStyle}
        margin-block-start: 4px;
      }
    }
  }
`;

export const StyledPostMagazineOnelineMenu = styled(EntityOnelineMenu)`
  display: none;

  ${theme.breakpoints.up("desktop")} {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ${MenuItem} {
    ${desktopMenuItemStyle}

    &[data-active="true"] {
      font-variation-settings: "wght" 700;
    }
  }

  ${StyledSwiperSlide} {
    &.swiper-slide {
      &:not(:last-child) {
        margin-inline-end: 13px;
        ${theme.breakpoints.up("tablet")} {
          margin-inline-end: 14px;
        }
        ${theme.breakpoints.up("desktop")} {
          margin-inline-end: 16px;
        }
      }
    }
  }

  ${StyledSwiper} {
    .swiper-button-next,
    .swiper-button-prev {
      block-size: 15.6px;
      ${theme.breakpoints.up("tablet")} {
        block-size: 16.8px;
      }
      ${theme.breakpoints.up("desktop")} {
        block-size: 19.2px;
      }
    }
    span {
      font-size: 13px;
      line-height: 15.6px;
      ${theme.breakpoints.up("tablet")} {
        font-size: 14px;
        line-height: 16.8px;
      }
      ${theme.breakpoints.up("desktop")} {
        line-height: 19.2px;
      }
    }
  }
`;
